<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode": "2KKN885S", "carNo": "粤SD3333"},
            responseCode: {
                "data": {
                    "couponList": [
                        {
                            "canCover": true,
                            "couponName": "金额扣减1元券201906141810217134",
                            "couponSn": "18609260300",
                            "couponTemplateId": 6,
                            "couponType": 1,
                            "extPro": "{\"free\":\"1\",\"rule\":\"0\"}",
                            "faceValue": "2",
                            "maxCoverNum": 10,
                            "useRule": "0<=${money}&&${money}<=999",
                            "validFrom": "2019-06-19 15:04:21",
                            "validTo": "2019-06-26 15:04:21"
                        },
                        {
                            "canCover": true,
                            "couponName": "金额扣减1元券201906141810217134",
                            "couponSn": "16917024563",
                            "couponTemplateId": 6,
                            "couponType": 1,
                            "extPro": "{\"free\":\"1\",\"rule\":\"0\"}",
                            "faceValue": "1",
                            "maxCoverNum": 10,
                            "useRule": "0<=${money}&&${money}<=999",
                            "validFrom": "2019-06-19 14:11:32",
                            "validTo": "2019-06-26 14:11:32"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询车牌号可用的城市运营券",
                t_url: this.commonUrls.test+"getCarValidCityOperationCoupon",
                p_url: this.commonUrls.prod+"getCarValidCityOperationCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponList', info2: '是', info3: 'String', info4: '优惠券列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠券名称' },
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '券编号' },
                        { info1: 'couponType', info2: '是', info3: 'int', info4: '券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效开始时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '有效结束时间 yyyy-MM-dd HH:mm:ss' },
                        { info1: 'userule', info2: '是', info3: 'String', info4: '使用规则表达式:0<=${money}&&${money}<=9999表示0到9999元之间可用' },
                        { info1: 'extPro', info2: '是', info3: 'String', info4: '额外属性' },
                        { info1: 'canCover', info2: '是', info3: 'boolean', info4: '是否可用叠加使用' },
                        { info1: 'maxCoverNum', info2: '是', info3: 'int', info4: '最大叠加数' },
                        { info1: 'couponTemplateId', info2: '是', info3: 'long', info4: '券模板id' },
                        { info1: 'couponTemplateCode', info2: '是', info3: 'String', info4: '券模板编码' },
                        { info1: 'couponRule', info2: '否', info3: 'int', info4: '时间券属性：0 扣减前面时间，1 扣减后面时间，2 扣减进场时间和优惠时间计算的金额，3 扣减优惠时间和计费结束时间计算的金额' },
                        { info1: 'useParkingFee', info2: '否', info3: 'int', info4: '时间券属性：0 不使用免费时长，1 使用免费时长' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/getCarValidCityOperationCoupon.vue